import { Component, computed, effect, inject, input, model, signal } from '@angular/core';
import { Button } from 'primeng/button';
import { Dialog } from 'primeng/dialog';
import { CompanyService } from '@/app/services/company.service';
import { Company } from '@/lib-backend';

@Component({
    selector: 'app-company-delete-dialog',
    standalone: true,
    imports: [Button, Dialog],
    templateUrl: './company-delete-dialog.html',
})
export class CompanyDeleteDialog {
    private readonly companyService = inject(CompanyService);

    readonly visible = model.required<boolean>();
    readonly company = input<Company | null>(null);
    readonly websiteCount = input<number>(0);

    protected readonly loading = signal(false);
    protected readonly error = signal<string | null>(null);

    protected readonly blocked = computed(() => this.websiteCount() > 0);

    constructor() {
        effect(() => {
            if (this.visible()) this.error.set(null);
        });
    }

    protected close(): void {
        this.visible.set(false);
    }

    protected async confirm(): Promise<void> {
        const c = this.company();
        if (!c) return;
        this.loading.set(true);
        this.error.set(null);
        try {
            const result = await this.companyService.deleteCompany(c.Id);
            switch (result) {
                case 'Ok':
                    this.close();
                    break;
                case 'HasActiveRealms':
                    this.error.set('This company still has active websites. Reassign or delete them first.');
                    break;
                case 'NotFound':
                    this.error.set('Company no longer exists.');
                    break;
                case 'AlreadyDeleted':
                    this.close();
                    break;
                default:
                    this.error.set('Failed to delete company.');
            }
        } finally {
            this.loading.set(false);
        }
    }
}
